/**
 * "A new version is waiting." Deploys used to reload every open page the
 * moment the new service worker installed (2026-08-28: an import lost its
 * defaults, a PDF review lost its zoom). The service worker now waits
 * (registerType 'prompt'); main.tsx announces here, the UpdateBanner asks,
 * and the person reloads when it suits them. Tiny external store so the
 * announcement can come from outside React.
 */
type Listener = () => void;

type State = { apply: (() => void) | null; dismissed: boolean };

let state: State = { apply: null, dismissed: false };
const listeners = new Set<Listener>();
const emit = () => listeners.forEach((l) => l());

export const updateStore = {
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  getSnapshot(): State {
    return state;
  },
  /** A new build is installed and waiting; `apply` activates it (and reloads). */
  announce(apply: () => void): void {
    state = { apply, dismissed: false };
    emit();
  },
  dismiss(): void {
    state = { ...state, dismissed: true };
    emit();
  },
  reset(): void {
    state = { apply: null, dismissed: false };
    emit();
  },
};
